import { Fragment } from 'react';

// Small label-over-value totals ("ITEMS │ CARAT │ AMOUNT …") with thin
// dividers between them — the totals bar under the Add/Edit Sale table, and
// the totals in the Add/Edit Purchase and Import Purchase footers. One
// figure can be `strong` (the headline number: bigger and bolder); `color`
// tints a value, e.g. red for an amount that comes off.

export interface TotalsFigure {
  label:   string;
  value:   string;
  color?:  string;
  strong?: boolean;
  title?:  string;
}

export function TotalsFigures({ figures }: { figures: TotalsFigure[] }) {
  return (
    <div style={{ display: 'flex', alignItems: 'stretch', gap: 14 }}>
      {figures.map((f, i) => (
        <Fragment key={f.label}>
          {i > 0 && <span style={{ width: 1, background: 'var(--border)' }} />}
          <div style={{ textAlign: 'right' }} title={f.title}>
            <div style={{ fontSize: 9.5, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--text-3)' }}>
              {f.label}
            </div>
            <div style={{
              fontFamily: 'var(--font-num)', whiteSpace: 'nowrap',
              fontSize: f.strong ? 14 : 12.5, fontWeight: f.strong ? 800 : 600,
              color: f.color ?? (f.strong ? 'var(--text-1)' : 'var(--text-2)'),
            }}>
              {f.value}
            </div>
          </div>
        </Fragment>
      ))}
    </div>
  );
}
